import 'reflect-metadata'
import router from '@/router'
import Vue from 'vue'
import store from '@/store'
import '@/plugins/axios'
import '@/plugins/vue-notification'
import '@/plugins/vue-config'
import i18n from '@/plugins/vue-i18n'
import '@/plugins/vee-validate'
import VueAppInsights from 'vue-application-insights'
import '@/plugins/string'
import vuetify from '@/plugins/vuetify'

Vue.use(VueAppInsights, {
  id: process.env.VUE_APP_APPLICATION_INSIGHT
})
const vue = new Vue({
  i18n,
  store,
  el: '#app-root',
  router,
  vuetify,
  render: (h: any) => h(require('./App.vue').default)
})
vue.$mount('#app')
